import { PRODUCT, ENTRYPOINT } from './config'
import postalCodes from './utils/postalCodes/result.json'

interface PostalCodeItem {
  codigo_postal: string | number
}

export const isSubscriptionJourney = (): boolean => {
  return PRODUCT === 'subscription'
}

export const isOneShop = (): boolean => {
  return ENTRYPOINT === 'oneshop'
}

export const isZipCodeValid = (zipcode: string | number): boolean =>
  `${zipcode}`.length === 5 &&
  postalCodes.some(
    (zpc: PostalCodeItem) => `${zipcode}` === `${zpc.codigo_postal}`
  )

export const getPrivacyPolicy = (): string => {
  return `${process.env.PUBLIC_URL}/assets/${process.env
    .REACT_APP_WEBSITE_BASE_BRAND ??
    'cupra'}/documents/Politica_de_proteccion_de_datos_OLES.pdf`
}
